import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/option.css";

const Options = ({ option, onOptionChange }) => {
	const { t } = useTranslation();
	const LICENSE = "LICENSE";
	const CONTRACT = "CONTRACT";

	const [searchOption, setSearchOption] = useState(option);

	useEffect(() => {
		setSearchOption(option);
	}, [option]);

	return (
		<>
			<div className="search-type-container">
				<div
					className={`search-type-item ${searchOption === LICENSE ? "active" : ""
						}`}
					onClick={() => onOptionChange(LICENSE)}
					role="button"
				>
					<div className="group-icon">
						<img src="images/car.svg" alt="" />
						<img src="images/calendar.svg" alt="" />
					</div>
					<div className="group-label">
						<span>{t("license")}</span>
						<span>&amp;</span>
						<span>{t("date")}</span>
					</div>
				</div>
				<div
					className={`search-type-item ${searchOption === CONTRACT ? "active" : ""
						}`}
					onClick={() => onOptionChange(CONTRACT)}
					role="button"
				>
					<div className="group-icon">
						<img src="images/contract.svg" alt="" />
						<img src="images/car.svg" alt="" />
					</div>
					<div className="group-label">
						<span>{t("contract")}</span>
						<span>&amp;</span>
						<span>{t("license")}</span>
					</div>
				</div>
			</div>
		</>
	);
};

export default Options;
